import React, { type ReactNode, type FC } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

interface IProps {
  state: boolean
  children: ReactNode
}

const Modal: FC<IProps> = ({ state, children }) => {
  return (
    <AnimatePresence mode='wait'>
      {state && (
        <>
          <motion.div
            key={'layer'}
            initial={{ background: 'transparent', opacity: 0 }}
            animate={{ background: 'black', opacity: 0.6 }}
            exit={{
              background: 'transparent',
              opacity: 0,
              transition: { delay: 0.2 },
            }}
            className='fixed top-0 left-0 right-0 bottom-0 z-40'
          ></motion.div>
          <motion.div
            key={'modal'}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: 0.2 } }}
            exit={{ opacity: 0 }}
            className='fixed top-1/2 left-6 right-6 -translate-y-1/2 bg-[#FDFBF9] p-6 z-50 lg:left-1/4 lg:right-1/4 lg:p-10 max-h-[50vh] overflow-auto'
          >
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default Modal
